<template>
	<div class="site-section interior">
    <section class="hero is-medium is-black is-vcentered">
      <div class="columns is-tablet">
        <div class="column is-one-third is-one-quarter-tablet is-full-mobile">
          <img src="../../assets/hero-daddy-academy.png">
        </div>
        <div class="column">
          <div class="hero-body">
            <h1 class="is-size-1 lucky-title">
              NFT 101
            </h1>
            <p class="intro">Welcome to NFDaddys NFT 101! Congratulations, you're early and we are ready to help you along your journey. Whether this is your first stop on your NFT & Crypto Journey, or are a seasoned veteran with hardware wallets for you and your family, our team is here to help you become NFT & Crypto Literate.</p>
          </div>
        </div>
      </div>
    </section>
    <section class="body-content">
      <div class="nft-101">
        <p class="mt-5">Through these videos you will learn what a Non-Custodial Crypto Wallet is, how to navigate the secondary NFT Market, and ultimately how to buy / sell / trade NFTs.</p>
        <p class="mt-5">This process will be like speaking a new language at first and once you are able to say Hello, Bye, and Where is the Bathroom you'll be navigating the NFT & Crypto market! Exciting stuff. Before we get too far along we have 2 rules that we must follow at all times to keep our assets safe: </p>

        <ol class="mt-5" style="margin-left: 50px;">
          <li>Never click on any links you did not ask for or from untrusted sites.</li>
          <li>Never give out your secret seed phrase to anyone!</li>
        </ol>

        <p class="mt-5">Let's get started!</p>

        <div class="columns mt-5">
          <div class="column text-left">
            <div v-for="item in videos" :key="item.title">
              <button
                v-on:click="selectVideo(item)"
                :class="selectedVideo == item ? 'is-warning' : ''"
                class="button is-light mb-4"
              >
                {{ item.title }}
              </button>
            </div>
          </div>
          <div class="column">
            <div v-if="selectedVideo != null">
              <iframe
                class="has-ratio"
                width="640"
                height="360"
                :src="selectedVideo.url"
                frameborder="0"
                allowfullscreen
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
	</div>
</template>

<style scoped>

.nft-101 {
  text-align: left;
}

</style>

<script>
/* eslint-disable no-console */
export default {
  name: "NFT101",
  created() {
    this.selectedVideo = this.videos[0];
  },
  methods: {
    selectVideo(video) {
      this.selectedVideo = video;
    },
  },
  data() {
    return {
      videos: [
        {
          title: "Brave Browser and Metamask Setup",
          url: "https://www.youtube.com/embed/YV8xeSOS9ug",
        },
        {
          title: "Metamask Add Funds",
          url: "https://www.youtube.com/embed/h2muW939w4o",
        },
        {
          title: "Do Not Get Scammed On Discord",
          url: "https://www.youtube.com/embed/FiCdMRCbKR4",
        },
        {
          title: "Navigating Opensea Secondary Market",
          url: "https://www.youtube.com/embed/xoq87-Q3JlY",
        },
        {
          title: "Understanding Crypto Wallet Activity",
          url: "https://www.youtube.com/embed/IsCE3M6JTHM",
        },
      ],
      selectedVideo: null,
    };
  },
};
/* eslint-enable no-console */
</script>
<!--
  <template>
  <div class="site-section text-center">

    <div style="position: relative;">
      <img src="../../assets/classroom.jpg" />
      <div class="cover"></div>
    </div>
    <div class="container width-medium">
      <h1 class="is-size-1 mb-2 lucky-title text-center">NFT 101</h1>

      <p>
        Welcome to NFDaddys NFT 101! Congratulations, you're early and we are
        ready to help you along your journey. Whether this is your first stop on your
        NFT & Crypto Journey, or are a seasoned veteran with hardware wallets for
        you and your family, our team is here to help you become NFT & Crypto
        Literate. Through these videos you will learn what a Non-Custodial
        Crypto Wallet is, how to navigate the secondary NFT Market, and
        ultimately how to buy / sell / trade NFTs.
      </p>

      <p class="mt-5">
        This process will be like speaking a new language at first and once you
        are able to say Hello, Bye, and Where is the Bathroom you'll be
        navigating the NFT & Crypto market! Exciting stuff. Before we get too
        far along we have 2 rules that we must follow at all times to keep our
        assets safe:
      </p>

      <ol style="margin: 0 auto; text-align: left; display: inline-block;" class="mt-5">
        <li>Never click on any links you did not ask for or from untrusted sites.</li>
        <li>Never give out your secret seed phrase to anyone!</li>
      </ol>

      <p class="mt-5">Let's get started!</p>

      <h1 class="is-size-1 mb-2 mt-5 lucky-title text-center">101 VIDEOS</h1>

      <div class="columns mt-5">
        <div class="column text-left">
          <div v-for="item in videos" :key="item.title">
            <button
              v-on:click="selectVideo(item)"
              :class="selectedVideo == item ? 'is-warning' : ''"
              class="button is-light mb-4"
            >
              {{ item.title }}
            </button>
          </div>
        </div>
        <div class="column">
          <div v-if="selectedVideo != null">
            <iframe
              class="has-ratio"
              width="640"
              height="360"
              :src="selectedVideo.url"
              frameborder="0"
              allowfullscreen
            ></iframe>
          </div>
        </div>
      </div>

      <h1 class="is-size-1 mb-2 mt-5 lucky-title text-center" id="glossary">Glossary</h1>
    </div>
  </div>
</template>
<script>
export default {
  name: "NFT",
  data() {
    return {
      videos: [
        {
          title: "Brave Browser and Metamask Setup",
          url: "https://www.youtube.com/embed/YV8xeSOS9ug",
        },
        {
          title: "Metamask Add Funds",
          url: "https://www.youtube.com/embed/h2muW939w4o",
        },
        {
          title: "Do Not Get Scammed On Discord",
          url: "https://www.youtube.com/embed/FiCdMRCbKR4",
        },
        {
          title: "Navigating Opensea Secondary Market",
          url: "https://www.youtube.com/embed/xoq87-Q3JlY",
        },
        {
          title: "Understanding Crypto Wallet Activity",
          url: "https://www.youtube.com/embed/IsCE3M6JTHM",
        },
      ],
      selectedVideo: null,
    };
  },
  created() {
    this.selectedVideo = this.videos[0];
  },
  methods: {
    selectVideo(video) {
      this.selectedVideo = video;
    },
  },
};
</script>
<style scoped>
.site-section {
  background: #ffffff;
  color: #000000;
  padding-bottom: 50px;
  /* margin-top: 85px; */
  min-height: 0;
}

img {
  width: 100%;
  height: 100%;
  padding-bottom: 50px;
}

.text-left {
  text-align: left;
}

.cover {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(180deg, rgba(2,0,36,0) 71%, rgba(255,255,255,1) 90%);
}

.width-medium {
  position: relative;
  top: -50px;
}
</style>
-->